import { useMutation, useQuery } from '@tanstack/react-query'
import { AxiosError } from 'axios'
import apis from '../../apis'
import { getJwtToken } from '../../auth'
import { axiosGet, axiosPost } from '../../axiosHelper'
import { useCurrentUser } from '../../context/UserContext'
import { promotionTicketStatusQueryApi, promotionTicketsQueryApi } from '../../react-query/queryApis'

interface IEntryTicket {
  id: number
  user_id: number
  used: boolean
  gift_type: string | undefined
}
export const usePromotionEntryTickets = () => {
  const { currentUser } = useCurrentUser()
  const token = getJwtToken()
  return useQuery<IEntryTicket[], AxiosError>({
    queryKey: promotionTicketsQueryApi.getQueryKey(),
    queryFn: promotionTicketsQueryApi.getQueryFn(),
    // onError: (e) => handleAxiosError(e),
    cacheTime: 0,
    enabled: !!token,
  })
}

export const usePromotionEntryTicketStatus = () => {
  const { currentUser } = useCurrentUser()
  const token = getJwtToken()
  return useQuery<boolean, AxiosError>({
    queryKey: promotionTicketStatusQueryApi.getQueryKey(),
    queryFn: promotionTicketStatusQueryApi.getQueryFn(),
    // onError: (e) => handleAxiosError(e),
    cacheTime: 0,
    enabled: !!token,
  })
}

export const useRedeemPromotionTicket = () => {
  return useMutation<AxiosError>({
    mutationFn: () => {
      return axiosPost(apis.promotion.ticketRedeem())
    },
  })
}

// Promotion Code API
const promotionCode = async () => {
  const response = await axiosGet(apis.promotion.code())
  return {
    promotion_id: response.promotion_id,
    start_time: response.start_time,
    end_time: response.end_time,
    displayed_end_time: response.displayed_end_time,
  }
}

export const usePromotionCode = (config = {}) => {
  return useQuery({
    queryKey: ['promotionCode'],
    queryFn: promotionCode,
    refetchOnWindowFocus: false,
    refetchOnMount: false,
    retry: false,
    ...config,
  })
}
